import helpers from '../helpers';

class HSBColor {
  constructor(hue, saturation, brightness, alpha = 1) {
    this.hue = hue;
    this.saturation = saturation;
    this.brightness = brightness;
    this.alpha = alpha;
    helpers.checkRange(hue, 360, 'hue');
    helpers.checkRange(saturation, 1, 'saturation');
    helpers.checkRange(brightness, 1, 'brightness');
    helpers.checkRange(alpha, 1, 'alpha');
  }
}

export default HSBColor;
